const l = "_linkCellRoot_6h4iy_1", o = {
  linkCellRoot: l
};
export {
  o as default,
  l as linkCellRoot
};
//# sourceMappingURL=index.es747.js.map
